import { i18nNsFactory } from '@atlas-frontend/i18n';
import React from 'react';
import translations from './NoContentItem.translations.json';
import { TextSecondary } from './typography';

const { addTranslations, useTranslation } = i18nNsFactory('no-content-option');
addTranslations(translations);

export function NoContentItem({ label }: { label?: string }) {
  const { t } = useTranslation();
  return <TextSecondary>{label ?? t('no-options')}</TextSecondary>;
}
